var color = {gray:'_1uyghc9c',blue:'_1uyghc9d',purple:'_1uyghc9e',yellow:'_1uyghc9f',green:'_1uyghc9g',red:'_1uyghc9h',pink:'_1uyghc9i',unknown:'_1uyghc9j'};
var shape = {circle:'_1uyghc9a',square:'_1uyghc9b'};
var size = {sm:'_1uyghc95',md:'_1uyghc96',lg:'_1uyghc97',xlg:'_1uyghc98'};
var smallAvatarGroupGap = '_1uyghc99';

export { color, shape, size, smallAvatarGroupGap };
//# sourceMappingURL=avatar-base.css.js.map
